// extracted by mini-css-extract-plugin
export default {"wrapper":"preview_wrapper__1Wwbm"};